export default "/images/51536beb58237e01251c7223e02781c8.avif";